import React from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import { actions } from 'react-redux-form/immutable'
import Loading from 'bisu-react-loading'

import { fetchCOR } from './actions'
import None from './none'
import Wrapper from './wrapper'

const COR = ({ __state }) => {
  if (__state.size === 0) {
    return <Loading />
  }

  if (__state.get('error')) {
    return <None msg={__state.get('error')} />
  } else {
    return <Wrapper data={__state} />
  }

}

COR.onEnter = (store) => () => {
  store.dispatch(fetchCOR())
    .then((res) => {
      if (res && !res.error) {
        store.dispatch(actions.change('corState', fromJS(res.payload || {})))
      }
    })
}

function mapStateToProps(state) {
  return {
    __state: state.corState,
  }
}

export default connect(mapStateToProps)(COR)



// WEBPACK FOOTER //
// ./src/containers/COR/index.js